export const IAnalyticsDataSourceType = Symbol('IAnalyticsDataSource');
export const IFirebaseAnalyticsDataSourceType = IAnalyticsDataSourceType;
